import { LOCATION_CHANGE } from 'react-router-redux'

const initialState = {
  currentPath: null
}

export function navigation(state = initialState, action) {
  switch (action.type) {
    case LOCATION_CHANGE:
      return Object.assign({}, state, {
        currentPath: action.payload.pathname
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/navigation.js